import { baseSnnSubjectiveReport } from '../validations/snn';
const shape = baseSnnSubjectiveReport.shape;
export const subjectiveReportFields = [
    { key: 'chiefComplaint', field: shape.chiefComplaint },
    { key: 'changeStatus', field: shape.changeStatus },
    { key: 'changeDetails', field: shape.changeDetails },
    { key: 'primaryConditionStatus', field: shape.primaryConditionStatus },
    { key: 'patientComplianceStatus', field: shape.patientComplianceStatus },
    { key: 'patientPresentDuringVisit', field: shape.patientPresentDuringVisit },
    { key: 'caregiverPresent', field: shape.caregiverPresent },
];
